import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combina clases de Tailwind, resolviendo conflictos automáticamente.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
